import type { MatchParams } from '@atlassian/react-resource-router';
import { ISSUEKEY_REGEX } from '@atlassian/jira-common-match-jira-url/src/index.tsx';
import { fireUIAnalytics, useAnalyticsEvents } from '@atlassian/jira-product-analytics-bridge';
import type { PushOrReplace } from './useRoutePushOrReplace.tsx';

export const useSelectedIssueParamRedirect = (
	params: MatchParams,
	pushOrReplace: PushOrReplace,
): void => {
	const { createAnalyticsEvent } = useAnalyticsEvents();

	const navigationItemId = params.navigationItemId ?? '';
	const issueKeyRegex = new RegExp(`^${ISSUEKEY_REGEX}$`);
	const isIssueKey = issueKeyRegex.test(navigationItemId);

	/*
	 * At some point the route config was changed from:
	 *
	 * .../:issueKey
	 * to
	 * .../:navigationItemId
	 *
	 * Where the :issueKey path param represented the selected issue key
	 * and the :navigationItemId path param represents the navigation item ID.
	 *
	 * We are performing a frontend redirect when we detect that an issue key
	 * is present in the position where the navigation item ID is expected.
	 *
	 * This ensures we maintain backwards compatibility with existing links
	 * when performing a SPA transition.
	 */
	if (isIssueKey) {
		fireUIAnalytics(createAnalyticsEvent({}), 'route redirected', {
			didIssueKeyRedirect: true,
		});
		pushOrReplace(
			{
				params: {
					navigationItemId: undefined,
				},
				query: {
					selectedIssue: navigationItemId,
				},
			},
			true,
		);
	}
};
